import {
  DateInput,
  FormInput,
  Grid,
  RadioGroupInput,
  FormGetter,
  FormSetter,
} from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Typography, Divider, Paper } from '@mui/material';
import React from 'react';

import { FormButton } from 'components/FormButton';

import { FilesField } from '../FilesField';
import { StepWrapper } from '../StepWrapper';

type DependentInfo = {
  voornaam: string;
  naam: string;
  verwantschap: string;
  geboortedatum: string;
  zorgbehoevend: string;
};

export default function Step() {
  return (
    <StepWrapper
      name="Andere personen ten laste"
      description="Typ hieronder de gegevens van andere personen ten laste (indien correct druk op 'volgende')"
      maxWidth={1000}
    >
      <FormGetter
        names={['dependents']}
        render={({ dependents = [] }) => (
          <Grid container spacing={0}>
            <Grid xs={12} sx={{ mb: 2 }}>
              <FormSetter
                render={(setValue) => (
                  <FormButton
                    variant="outlined"
                    onClick={() => {
                      setValue('dependents', [
                        ...dependents,
                        {
                          voornaam: '',
                          naam: '',
                          verwantschap: '',
                          geboortedatum: '',
                          zorgbehoevend: '',
                        },
                      ]);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Persoon toevoegen
                  </FormButton>
                )}
              />
            </Grid>

            {dependents.map((dependent: DependentInfo, index: number) => (
              <Grid xs={12} key={index}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 3,
                    mb: 2,
                    width: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.02)',
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Typography variant="h6" color="primary">
                      Persoon {index + 1}
                    </Typography>
                    <FormSetter
                      render={(setValue) => (
                        <FormButton
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => {
                            const newDependents = [...dependents];
                            newDependents.splice(index, 1);
                            setValue('dependents', newDependents);
                          }}
                          startIcon={<DeleteIcon />}
                        >
                          Verwijderen
                        </FormButton>
                      )}
                    />
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Grid container spacing={2}>
                    <FormInput
                      name={`dependents.${index}.voornaam`}
                      label="Voornaam"
                      xs={12}
                      sm={6}
                      required
                    />
                    <FormInput
                      name={`dependents.${index}.naam`}
                      label="Naam"
                      xs={12}
                      sm={6}
                      required
                    />
                    <FormInput
                      name={`dependents.${index}.verwantschap`}
                      label="Verwantschap"
                      xs={12}
                      sm={6}
                      md={4}
                      required
                    />
                    <DateInput
                      name={`dependents.${index}.geboortedatum`}
                      label="Geboortedatum"
                      xs={12}
                      sm={6}
                      md={4}
                      required
                    />
                    <RadioGroupInput
                      name={`dependents.${index}.zorgbehoevend`}
                      label="Zorgbehoevend"
                      items={[
                        { text: 'Nee', value: 'nee' },
                        { text: 'Ja', value: 'ja' },
                      ]}
                      xs={12}
                      sm={6}
                      md={4}
                      required
                    />
                    <FormGetter
                      names={[`dependents.${index}.zorgbehoevend`]}
                      render={(values) => {
                        if (
                          values[`dependents.${index}.zorgbehoevend`] !== 'ja'
                        ) {
                          return null;
                        }

                        return (
                          <FilesField
                            name={`dependents.${index}.documenten`}
                            title="Upload hier (indien van toepassing) het attest van zorgbehoevendheid"
                            xs={12}
                            md={12}
                          />
                        );
                      }}
                    />
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
      />
    </StepWrapper>
  );
}
